import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import { SingleInput, SingleText } from '../../Res/BaseInput';
import { SubmitButton, CancelButton, SingleBigButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { getUserInfo, getval2Token, setVal2Token } from '../../../Login/Auth';
import moment from 'moment';
import { getOnlyDate, getOnlyDateSlash } from '../../../../item/ItemTools';
import { ReqRecruitmentContractorCaseInfo, CASE_STATUS_RESIGN, RespRecruitmentContractorDetail, CASE_STATUS_RESERVE, CASE_STATUS_RESERVE_STRING, CASE_STATUS_ONBOARD, CASE_STATUS_CANCEL, CASE_STATUS_ONBOARD_STRING, CASE_STATUS_CANCEL_STRING, CASE_STATUS_RESIGN_STRING, ReqCaseInfoText, CASE_STATUS_RESIGN_SHORT_STRING } from '../../../../item/ItemRecruitmentContractor';
import { api_updateRecruitmentContractor } from '../../../../api/apiRecruitmentContractor';
import { api_getRecruitmentPerformanceContractorRelatedDetail } from '../../../../api/apiRecruitmentPerformanceContractorRelated';
import { ReqRecruitmentContractorDetail } from '../../../../item/ItemRecruitmentPerformanceContractorRelated';
import { RecruitmentContractorStatusResume } from './RecruitmentContractorStatusResume';
import { RecruitmentContractorStatusProcess } from './RecruitmentContractorStatusProcess';


export function ResignSOP({ id, setIsLoading }) {
  const [tokenId, setTokenId] = useState("")
  const [recruitmentContractorId, setRecruitmentContractorId] = useState("")
  const [companyId, setCompanyId] = useState("")
  const [departmentId, setDepartmentId] = useState()
  const [customerContractId, setCustomerContractId] = useState("")
  const [customerPositionId, setCustomerPositionId] = useState("")

  const [userInfo] = useState(getUserInfo())
  const [detail, setDetail] = useState(new RespRecruitmentContractorDetail({}))

  const [caseContractor, setCaseContractor] = useState("")

  const [caseStatus, setCaseStatus] = useState(0)
  const [caseStatusString, setCaseStatusString] = useState("")

  const [caseCreateDate, setCaseCreateDate] = useState()
  const [caseReserveDate, setCaseReserveDate] = useState()
  const [caseCancelDate, setCaseCancelDate] = useState()
  const [caseOnBoardDate, setCaseOnBoardDate] = useState()
  const [caseResignDate, setCaseResignDate] = useState()

  const [caseOwner, setCaseOwner] = useState("")
  const [caseOwnerName, setCaseOwnerName] = useState("")

  const [caseContractorName, setCaseContractorName] = useState("")
  const [caseSexAge, setCaseSexAge] = useState("")
  const [caseMobile, setCaseMobile] = useState("")
  const [caseSignAt, setCaseSignAt] = useState("")
  const [caseCompanyName, setCaseCompanyName] = useState("")
  const [caseCustomerPosition, setCaseCustomerPosition] = useState("")
  const [caseWorkPlace, setCaseWorkPlace] = useState("")
  const [caseWorkAddress, setCaseWorkAddress] = useState("")
  const [caseProcessDescription, setCaseProcessDescription] = useState([])
  const [caseComment, setCaseComment] = useState([])

  const [comment, setComment] = useState("")
  const [processDescription, setProcessDescription] = useState("")

  const [isClosed, setIsClosed] = useState(0)
  const [isDelete, setIsDelete] = useState(0)
  const [creatAccountId, setCreatAccountId] = useState("")
  const [creatAt, setCreatAt] = useState("")

  // const [laborInsuranceStatusCode, setLaborInsuranceStatusCode] = useState("0") //勞保狀態參數
  // const [laborPensionStatusCode, setLaborPensionStatusCode] = useState("0")     //勞退狀態參數
  // const [healthInsuranceStatusCode, setHealthInsuranceStatusCode] = useState("0") //健保狀態 參數
  // const [groupInsuranceStatusCode, setGroupInsuranceStatusCode] = useState("0")     //團保狀態參數

  // const [laborInsuranceType, setLaborInsuranceType] = useState("0")
  // const [laborInsuranceLevel, setLaborInsuranceLevel] = useState("0")
  // const [healthInsuranceLevel, setHealthInsuranceLevel] = useState("0")


  // const [signAtError, setSignAtError] = useState(false)

  const [isBlacklist, setIsBlacklist] = useState(false)
  const [isBlacklistStr, setIsBlacklistStr] = useState("")

  const [showViewResume, setShowViewResume] = useState(false)
  const [showViewProcess, setShowViewProcess] = useState(false)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var rId = getval2Token("recruitmentContractorId", id)
      setRecruitmentContractorId(rId)

      setTokenId(id)
      setCaseContractor(rId)
    }
  }, [id])

  useEffect(() => {
    if (recruitmentContractorId !== undefined && recruitmentContractorId !== "") {
      getDetail()
    }
  }, [recruitmentContractorId])

  function getDetail() {
    setIsLoading(true)
    var mReqRecruitmentContractorDetail = new ReqRecruitmentContractorDetail({
      recruitmentContractorId,
    })
    console.log(mReqRecruitmentContractorDetail)
    api_getRecruitmentPerformanceContractorRelatedDetail({
      mReqRecruitmentContractorDetail,
      success: (result) => {
        // console.log(result)
        var detail = result.detail
        console.log(detail)
        var mRespRecruitmentContractorDetail = new RespRecruitmentContractorDetail({})
        mRespRecruitmentContractorDetail.fromJson(detail)
        console.log(tokenId)
        setVal2Token('recruitmentContractorStatusDetail', detail, tokenId)
        console.log(mRespRecruitmentContractorDetail)
        setDetail(mRespRecruitmentContractorDetail)
        setCompanyId(mRespRecruitmentContractorDetail.companyId)
        setDepartmentId(mRespRecruitmentContractorDetail.departmentId)
        setCaseContractor(mRespRecruitmentContractorDetail.caseContractor)
        setCaseContractorName(mRespRecruitmentContractorDetail.caseContractorName)

        setBlacklist(detail.isBlacklist)

        var sex = mRespRecruitmentContractorDetail.caseContractorSex === "1" ? "男" : mRespRecruitmentContractorDetail.caseContractorSex === "2" ? "女" : ""
        var age = mRespRecruitmentContractorDetail.caseContractorAge
        setCaseSexAge(sex + "/" + age)
        console.log(mRespRecruitmentContractorDetail.caseContractorMobile)
        setCaseMobile(mRespRecruitmentContractorDetail.caseContractorMobile)
        setCaseStatus(mRespRecruitmentContractorDetail.caseStatus)
        var statusString = ""
        switch (mRespRecruitmentContractorDetail.caseStatus) {
          case CASE_STATUS_RESERVE:
            statusString = CASE_STATUS_RESERVE_STRING + " "
              + moment(mRespRecruitmentContractorDetail.caseInfo.caseReserveDate).format('YYYY/MM/DD')
            break;
          case CASE_STATUS_ONBOARD:
            statusString = CASE_STATUS_ONBOARD_STRING + " "
              + moment(mRespRecruitmentContractorDetail.caseInfo.caseOnBoardDate).format('YYYY/MM/DD')
            break;
          case CASE_STATUS_CANCEL:
            statusString = CASE_STATUS_CANCEL_STRING + " "
              + moment(mRespRecruitmentContractorDetail.caseInfo.caseCancelDate).format('YYYY/MM/DD')
            break;
          case CASE_STATUS_RESIGN:
            statusString = CASE_STATUS_RESIGN_STRING + " "
              + moment(mRespRecruitmentContractorDetail.caseInfo.caseResignDate).format('YYYY/MM/DD')
            break;
          default:
            break;
        }
        setCaseStatusString(statusString)

        setIsClosed(mRespRecruitmentContractorDetail.isClosed)
        setIsDelete(mRespRecruitmentContractorDetail.isDelete)
        setCaseOwner(mRespRecruitmentContractorDetail.caseOwner)
        setCaseOwnerName(mRespRecruitmentContractorDetail.caseOwnerName)
        setCreatAccountId(mRespRecruitmentContractorDetail.creatAccountId)
        setCreatAt(mRespRecruitmentContractorDetail.creatAt)

        console.log(mRespRecruitmentContractorDetail.caseInfo.customerPositionId)
        setCustomerPositionId(mRespRecruitmentContractorDetail.caseInfo.customerPositionId)
        setCaseCreateDate(mRespRecruitmentContractorDetail.caseInfo.caseCreateDate)
        setCaseReserveDate(mRespRecruitmentContractorDetail.caseInfo.caseReserveDate)
        setCaseCompanyName(mRespRecruitmentContractorDetail.caseInfo.caseCompanyName)
        setCaseSignAt(mRespRecruitmentContractorDetail.caseInfo.caseSignAt)
        setCaseCustomerPosition(mRespRecruitmentContractorDetail.caseInfo.caseCustomerPosition)
        setCaseWorkPlace(mRespRecruitmentContractorDetail.caseInfo.caseWorkPlace)
        setCaseWorkAddress(mRespRecruitmentContractorDetail.caseInfo.caseWorkAddress)
        setCaseProcessDescription(mRespRecruitmentContractorDetail.caseInfo.caseProcessDescription)
        setCaseComment(mRespRecruitmentContractorDetail.caseInfo.caseComment)
        setCaseCancelDate(mRespRecruitmentContractorDetail.caseInfo.caseCancelDate)
        setCaseOnBoardDate(mRespRecruitmentContractorDetail.caseInfo.caseOnBoardDate)
        //setCaseResignDate(mRespRecruitmentContractorDetail.caseInfo.caseResignDate)
        setCaseResignDate(getOnlyDate())
        setIsLoading(false)
      },
      failure: (err) => {
        //console.log(err)
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err.message,
        }).then(() => {
          window.history.go(-1)
        })
      }
    })
  }

  function setReqRecruitmentContractorCaseInfo() {
    var cp = caseProcessDescription
    cp.push(new ReqCaseInfoText({ id:caseOwner, name: caseOwnerName, text: getOnlyDate() + " "+CASE_STATUS_RESIGN_SHORT_STRING }))
    var cc = caseComment
    if (comment !== "")
      cc.push(new ReqCaseInfoText({ id:caseOwner, name: caseOwnerName, text: comment }))
    var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({
      caseCreateDate,
      caseReserveDate,
      customerPositionId,
      // caseContractorName,
      // caseSexAge,
      // caseMobile,
      caseSignAt,
      caseCompanyName,
      caseWorkPlace,
      caseWorkAddress,
      caseCustomerPosition,
      caseProcessDescription: cp,
      caseComment: cc,
      caseCancelDate,
      caseOnBoardDate,
      caseResignDate
    })
    return mReqRecruitmentContractorCaseInfo
  }

  function setRespRecruitmentContractorDetail(mReqRecruitmentContractorCaseInfo) {
    var mRespRecruitmentContractorDetail = new RespRecruitmentContractorDetail({
      recruitmentContractorId,
      companyId,
      departmentId,
      caseContractor,
      caseStatus: CASE_STATUS_RESERVE,
      caseInfo: JSON.stringify(mReqRecruitmentContractorCaseInfo),
      isClosed,
      isDelete,
      caseOwner,
      creatAccountId,
      creatAt
    })
    //console.log(mRespRecruitmentContractorDetail)
    return mRespRecruitmentContractorDetail
  }

  function toCancel() {
    window.history.go(-1)
  }

  function checkCaseOwner(){
    if(userInfo.accountId === caseOwner){
      return true
    }
    return false
  }

  function cantAction(){
    Swal.fire({
      type: 'error',
      title: '提醒',
      text: "需案件擁有者才可操作",
    }).then(() => {
    })
  }
  
  function toResign() {
    if(!checkCaseOwner()){
      cantAction()
      return
    }
    setIsLoading(true)
    var mReqRecruitmentContractorCaseInfo = setReqRecruitmentContractorCaseInfo()
    //console.log(mReqRecruitmentContractorCaseInfo)
    var mRespRecruitmentContractorDetail = setRespRecruitmentContractorDetail(mReqRecruitmentContractorCaseInfo)
    mRespRecruitmentContractorDetail.caseStatus = CASE_STATUS_RESIGN

    console.log(mRespRecruitmentContractorDetail)
    updateRecruitmentContractor(mRespRecruitmentContractorDetail, '設定為已離職')
  }

  function updateRecruitmentContractor(mRespRecruitmentContractorDetail, title) {
    api_updateRecruitmentContractor({
      mRespRecruitmentContractorDetail,
      success: (jsonData) => {
        console.log(jsonData)
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title,
        }).then(() => {
          window.history.go(-1)
        })
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function setBlacklist(isBlack){

    setIsBlacklist(isBlack)
    setIsBlacklistStr(isBlack?"--黑名單":"")
  }

  function toViewResume() {
    setShowViewResume(true)
    setShowViewProcess(false)
  }

  function toViewProcess() {
    setShowViewResume(false)
    setShowViewProcess(true)
  }

  var title = <>
    <span className="text-primary">離職作業：</span>
    <span className="text-success">{caseContractorName}</span>
    <span className="text-primary">目前的工作狀態</span>
  </>
  var title_tools =
      <a className="dropdown-toggle " onClick={e => toResign()} data-toggle="dropdown" href="#A">
        <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">進行離職作業</span>
      </a>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"工作狀態"} val={caseStatusString} />
          <SingleText title={"性別/年齡"} val={caseSexAge} />
          <SingleText title={"手機號碼"} val={caseMobile} />
          <SingleText title={"本次預定專員"} val={caseOwnerName} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"合約廠商"} val={caseSignAt + " " + caseCompanyName} />
          <SingleText title={"職缺"} val={caseCustomerPosition} />
          <SingleText title={"工作地點"} val={caseWorkPlace} />
          <SingleText title={"工作地址"} val={caseWorkAddress} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"勞保狀態"} val={"加保中、2019/12/25、28,800"} />
          <SingleText title={"勞退狀態"} val={"已退保、2019/12/25、28,800"} />
          <SingleText title={"健保狀態"} val={"已退保、2019/12/25、28,800"} />
          <SingleText title={"團保保狀態"} val={"N/A"} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"本次作業的評論/備註"} val={comment} action={setComment} placeholder={"請儘量簡短"} size={6} />
          <SingleText title={"離職日期"} val={caseResignDate} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-2">
            <p>親愛的招募人員請注意</p>
          </div>
          <div className="col-md-10">
            <strong>1. “確定離職”是不可逆的，請三思！ <p></p>
              2. “離職日期”是“退保日期”！請於離職當日再進行本作業。<p></p>
              3. 如果“逾期”，請洽詢您的主管。<p></p>

            </strong>
          </div>
        </div>
      </div>
    </>
  var footer =
    <div className="row text-right ">
      <div className="col-sm-12">
        <CancelButton action={toCancel} />
        <SubmitButton action={toResign} name={"確定離職"} />
      </div>
    </div>


var moreTitle = "更多詳細資料，請點選下方按鈕"
var moreContent =
  <>
    <div className="row">
      <div className="col-md-12">
        <SingleBigButton name={"檢視履歷表"} action={toViewResume} />
        <SingleBigButton name={"檢視派遣歷程"} action={toViewProcess} />
      </div>
    </div>
  </>

  return (
    <>
      <ContentBox title={title} /*title_tools={title_tools}*/ titleSize={6} content={content} footer={footer} hasDrawer={false} />

      <ContentBox title={moreTitle} titleSize={6} content={moreContent} hasDrawer={false} />
      {!showViewResume ? <></> :
        <RecruitmentContractorStatusResume rId={caseContractor} setIsLoading={setIsLoading} isAdmin={false} />
      }
      {!showViewProcess ? <></> :
        <RecruitmentContractorStatusProcess id={tokenId} ibl={isBlacklist} ibls={isBlacklistStr} n={caseContractorName} setBL={setBlacklist} setIsLoading={setIsLoading} isAll={false} />
      }
    </>
  )
}

